
import React, { Component } from "react";
import { Alert, Card, CardBody, Col, Container, Row } from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// action
import { forgetUser, resetForgetPWState, resetLoginActionState, resetPasswordUser } from '../../store/actions';

// import images
import { Box, Grid, IconButton, Stack } from "@mui/material";
import { Icon } from "@iconify/react/dist/iconify.js";
import LoadingDialog from "../../components/Common/LoadingDialog";
import withRouter from "../../components/Common/withRouter";
import CustomButton from "../../components/Form/CustomButton";
import CustomTextField from "../../components/Form/CustomTextField";
import loginBg from '../../assets/images/login-background.jpg';
import Logo from '../../assets/images/Logo.png';
import Notification from "../../components/Common/Notification";

const token = new URLSearchParams(window.location.search).get("token");
const email = new URLSearchParams(window.location.search).get("email");
class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            email: '',
            emailSent: false,
            resetPassword: false,
            showPWRe: false,
            showPw: false,
            resetPwSent: false,
            notification: {
                open: false,
                msg: "",
                type: "success",
            }
        };

        // handleValidSubmit
        this.handleValidSubmit = this.handleValidSubmit.bind(this);
        this.handleResend = this.handleResend.bind(this);
        this.props.resetForgetPWState();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.resetPasswordRes !== this.props.resetPasswordRes) {
            if (this.props.resetPasswordRes?.code === 'success') {
                this.setState({
                    loading: false,
                    notification: { open: true, msg: 'Password reset successfully', type: 'success' },
                });
                this.props.resetLoginActionState();

                setTimeout(() => {
                    this.props.router.navigate("/login");
                }, 1000);
            }
        }

        if (prevProps.loginError !== this.props.loginError) {
            if (this.props.loginError) {
                this.setState({
                    loading: false,
                    notification: {
                        open: true,
                        msg: this.props.loginError?.code === 'invalid_field' ? 'Invalid field' : this.props.loginError?.message || 'Something went wrong',
                        type: 'error'
                    }
                });
                this.props.resetLoginActionState();
            }
        }
    }

    // handleValidSubmit
    handleValidSubmit() {
        this.setState({ loading: true });
        const values = {
            email: this.state.email,
        }
        // this.props.forgetUser(values);
        this.setState({ loading: false, emailSent: true, resetPassword: false });
        // window.location.href = "/password-sent";
    }

    handleResend() {
        this.setState({ loading: false, emailSent: false, resetPassword: false, email: "" });
    }

    handleResetPassword() {
        this.setState({ loading: true });
        const values = {
            email: email,
            password: this.state.new_password,
            password_confirmation: this.state.confirm_password,
            token: token,
        }
        this.props.resetPasswordUser(values);
        // this.setState({ loading: false, emailSent: false, resetPassword: true });
    }

    handleResetPw() {
        this.setState({ resetPwSent: true });
    }

    render() {
        return (
            <React.Fragment>
                <div style={{ backgroundColor: '#F1F5F7', height: '100vh' }}>
                    <LoadingDialog open={this.state.loading} />
                    <Notification notification={this.state.notification} setNotification={(e) => this.setState({ notification: e })} />
                    <Container fluid className="p-0">
                        <Grid container>
                            <Grid item md={8} sm={12} xs={12} style={{ backgroundColor: 'white' }}>
                                <div style={{ height: '100vh' }} className={this.props.currentWidth <= 768 ? '' : 'd-flex align-items-center justify-content-center'}>
                                    <Box sx={{ minWidth: '50%', border: this.props?.currentWidth <= 768 ? '1px solid #E3E8EE' : 'none', borderRadius: 5 }} p={this.props?.currentWidth <= 768 ? 4 : 2} py={this.props?.currentWidth <= 768 && 6} m={this.props?.currentWidth <= 768 && 5}>
                                        <img src={Logo} style={{ height: '27px', objectFit: 'contain' }} />
                                        <div className={`text-bold font-size-24`} style={{ marginBlock: '35px' }}>
                                            Reset password
                                        </div>
                                        <CustomTextField
                                            placeholder='New password'
                                            typePw={this.state.showNewPW ? 'text' : 'password'}
                                            title={"New Password"}
                                            error={this.props.loginError?.errors?.password}
                                            values={this.state.new_password}
                                            onChange={(e) => this.setState({ new_password: e })}
                                            InputProps={{
                                                endAdornment: <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={(e) => this.setState({ showNewPW: !this.state.showNewPW })}
                                                    edge="end"
                                                >
                                                    {this.state.showNewPW ? <Icon icon="ri:eye-line" width="24" height="24" /> : <Icon icon="ri:eye-close-line" width="24" height="24" />}
                                                </IconButton>,
                                            }}
                                        />
                                        <div className='mt-3'>
                                            <CustomTextField
                                                placeholder='Confirm new password'
                                                typePw={this.state.showPW ? 'text' : 'password'}
                                                title={"Confirm New Password"}
                                                error={this.props.message?.errors?.password}
                                                values={this.state.confirm_password}
                                                onChange={(e) => this.setState({ confirm_password: e })}
                                                InputProps={{
                                                    endAdornment: <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={(e) => this.setState({ showPW: !this.state.showPW })}
                                                        edge="end"
                                                    >
                                                        {this.state.showPW ? <Icon icon="ri:eye-line" width="24" height="24" /> : <Icon icon="ri:eye-close-line" width="24" height="24" />}
                                                    </IconButton>,
                                                }}
                                            />
                                        </div>

                                        <div className="mt-3 text-center">
                                            <CustomButton
                                                title={'Reset password'}
                                                width={'100%'}
                                                padding={25}
                                                press={() => this.handleResetPassword()}
                                            />
                                        </div>
                                    </Box>
                                </div>
                            </Grid>
                            {
                                this.props?.currentWidth > 768 &&
                                <Grid item md={4} sm={0} xs={0} >
                                    <img src={loginBg} style={{ objectFit: 'cover', height: '100vh', width: '100%' }} />
                                </Grid>
                            }
                        </Grid>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { message, forgetError, loading } = state.Forget;
    const { currentWidth } = state.Layout;
    const { resetPasswordRes, loginError } = state.Login;
    return { message, forgetError, loading, currentWidth, resetPasswordRes, loginError };
}

export default withRouter(
    connect(mapStatetoProps, { forgetUser, resetForgetPWState, resetPasswordUser, resetLoginActionState })(ResetPassword)
);
